















import { Component, Prop, Emit, Vue } from "vue-property-decorator";

@Component({ name: "MessageDialog" })
export default class MessageDialog extends Vue {
  @Prop() dialog: boolean | undefined;
  @Prop() title: string | undefined;
  @Prop() subtitle: string | undefined;
  @Prop() message: string | undefined;
  @Prop() dialogStyle!: string | undefined;

  get headerClass() {
    if (this.dialogStyle == "warning") {
      return "warning-title";
    } else if (this.dialogStyle == "error") {
      return "error-title";
    } else if (this.dialogStyle == "success") {
      return "success-title";
    } else {
      return "default-title";
    }
  }
  
  @Emit()
  close() {}
}
